<template>
  <div>
    <v-dialog
        v-model="showMain"
        :max-width="this.currentBlock.type === 'ARBL' ? '1000px' : '450px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Zeitabschnitt {{timeBlock ? 'bearbeiten' : 'erstellen'}} {{'(' + duration+ ' Std.)'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <v-dialog
                        ref="start_time"
                        v-model="showStart"
                        :return-value.sync="startTime"
                        persistent
                        width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="startTime"
                            label="Beginnzeit"
                            prepend-icon="mdi-clock-in"
                            readonly
                            :error-messages="errorStart"
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="showStart"
                          v-model="startTimeEdit"
                          full-width
                          format="24hr"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="showStart = false; startTimeEdit = startTime"
                        >
                          Abbrechen
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.start_time.save(startTimeEdit)"
                        >
                          Ok
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>
                  <v-col><v-dialog
                      ref="end_time"
                      v-model="showEnd"
                      :return-value.sync="endTime"
                      persistent
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="endTime"
                          label="Endzeit"
                          prepend-icon="mdi-clock-out"
                          readonly
                          :error-messages="errorEnd"
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        v-if="showEnd"
                        v-model="endTimeEdit"
                        full-width
                        format="24hr"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="showEnd = false; endTimeEdit = endTime"
                      >
                        Abbrechen
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.end_time.save(endTimeEdit)"
                      >
                        Ok
                      </v-btn>
                    </v-time-picker>
                  </v-dialog></v-col>
                </v-row>
                <v-divider/>
                <v-row v-if="currentBlock.type === ''">
                  <v-col>
                    <p class="subtitle-1" style="font-size: 1.2rem !important; color: rgba(0, 0, 0, 0.87);">Tätigkeit / Fehlzeit</p>
                    <v-btn
                        block
                        tile
                        color="success"
                        style="height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                        @click="$refs.select_task_dialog.openDialog();"
                    >
                      <v-icon left>
                        mdi-plus
                      </v-icon>
                      Hinzufügen
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else-if="currentBlock.type === 'PAUS'">
                  <v-col>
                    <p style="margin-bottom: 0px">Arbeitsunterbrechung</p>
                    <p class="subtitle-1" style="font-size: 1.2rem !important; color: rgba(0, 0, 0, 0.87); margin-bottom: 0px">Pause</p>
                  </v-col>
                  <v-col>
                    <v-btn
                        block
                        tile
                        color="success"
                        style="
                        margin-top: 12px;
                        height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                        @click="$refs.select_task_dialog.openDialog();"
                    >
                      <v-icon left>
                        mdi-pencil
                      </v-icon>
                      Ändern
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else-if="currentBlock.type === 'FEHL'">
                  <v-col>
                    <p style="margin-bottom: 0px">Fehlzeit</p>
                    <p class="subtitle-1" style="font-size: 1.2rem !important; color: rgba(0, 0, 0, 0.87); margin-bottom: 0px">{{currentBlock.title}}</p>
                  </v-col>
                  <v-col>
                    <v-btn
                        block
                        tile
                        color="success"
                        style="
                        margin-top: 12px;
                        height: 32px;
                          border-radius: 14px;
                          color: white !important;"
                        @click="$refs.select_task_dialog.openDialog();"
                    >
                      <v-icon left>
                        mdi-pencil
                      </v-icon>
                      Ändern
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else-if="currentBlock.type === 'ARBL'">
                  <v-col>
                    <v-card-title style="padding: 2px; font-size: 1rem; padding-left: 12px; margin-bottom: 12px; margin-top: -8px">
                      Arbeitsabschnitt
                    </v-card-title>
                    <v-text-field
                        v-if="currentBlock.task !== currentBlock.title"
                        v-model="currentBlock.task"
                        :append-outer-icon="'mdi-pencil'"
                        :prepend-icon="'mdi-clipboard-check'"
                        :label="'Aufgabe Wo'"
                        type="text"
                        readonly
                        @click:append-outer="$refs.select_task_dialog.openDialog()"
                    ></v-text-field>
                    <v-text-field
                        v-model="currentBlock.title"
                        :append-outer-icon="'mdi-pencil'"
                        :prepend-icon="'mdi-clipboard-check'"
                        :label="currentBlock.task === currentBlock.title ? 'Objekt' : 'Aufgabe'"
                        type="text"
                        readonly
                        @click:append-outer="$refs.select_task_dialog.openDialog()"
                    ></v-text-field>
                    <v-text-field
                        v-model="currentBlock.legr"
                        :append-outer-icon="'mdi-pencil'"
                        :prepend-icon="'mdi-briefcase'"
                        :label="'Tätigkeit'"
                        hint="Bitte Tätigkeit auswählen"
                        type="text"
                        readonly
                        @click:append-outer="$refs.select_lear_dialog.openDialog()"
                    ></v-text-field>
                    <v-textarea
                        clearable
                        outlined
                        clear-icon="mdi-close-circle"
                        label="Hinweis"
                        :value="currentBlock.hinweis"
                        hide-details
                    ></v-textarea>
                    <v-checkbox
                        v-if="showFinishTodo"
                        v-model="finishTodo"
                        label="Aufgabe als erledigt melden ?"
                    ></v-checkbox>

                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="7" v-if="currentBlock.type === 'ARBL'" style="border-left: #e1e1e1 solid 1px">
                <v-row>
                  <v-col style="padding-top: 0px; padding-bottom: 0px">

                    <v-divider style="margin: 0; margin-top: 2px"></v-divider>
                    <v-row>
                      <v-col>
                    <v-card-title style="padding: 2px; font-size: 1rem; padding-left: 12px;">
                      Zulagen
                    </v-card-title>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                            class=""
                            text
                            icon
                            color="green"
                            @click="$refs.select_ez_dialog.openDialog();"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider style="margin: 0"></v-divider>
                    <v-data-table
                        :headers="headers_surcharges"
                        :items="items_surcharges"
                        hide-default-footer
                        hide-default-header
                        disable-pagination
                        disable-sort
                        style="max-height: 11vh; min-height: 11vh; overflow-y: auto"
                    >
                      <template v-slot:item.action="{ item }">
                        <v-btn
                            class=""
                            text
                            icon
                            color="green"
                            @click="currentEzDuration = item.work.std; currentEzId = item.id; showEzDuration = true;"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                            class=""
                            text
                            icon
                            color="red"
                            @click="deleteEz(item.id)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                    <v-divider style="margin: 0"></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="padding-top: 0px; padding-bottom: 0px">
                    <v-row>
                      <v-col>
                        <v-card-title style="padding: 2px; font-size: 1rem; padding-left: 12px;">
                          Fahrzeuge und Geräte
                        </v-card-title>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                            class=""
                            text
                            icon
                            color="green"
                            @click="$refs.select_fahr_dialog.openDialog();"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider style="margin: 0"></v-divider>
                    <v-data-table
                        :headers="headers_fahrs"
                        :items="items_fahrs"
                        hide-default-header
                        hide-default-footer
                        disable-pagination
                        disable-sort
                        style="max-height: 11vh; min-height: 11vh; overflow-y: auto"
                    >
                      <template v-slot:item.action="{ item }">
                        <v-btn
                            class=""
                            text
                            icon
                            color="green"
                            @click="currentFahrDuration = item.work.std; currentFahrId = item.id; showFahrDuration = true;"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                            class=""
                            text
                            icon
                            color="red"
                            @click="deleteFahr(item.id)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>

                    </v-data-table>
                    <v-divider style="margin: 0"></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="padding-top: 0px; padding-bottom: 0px">
                    <v-row>
                      <v-col>
                        <v-card-title style="padding: 2px; font-size: 1rem; padding-left: 12px;">
                          Material
                        </v-card-title>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                            class=""
                            text
                            icon
                            color="green"
                            @click="$refs.select_artis_dialog.openDialog();"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider style="margin: 0"></v-divider>
                    <v-data-table
                        :headers="headers_artis"
                        :items="items_artis"
                        hide-default-header
                        hide-default-footer
                        disable-pagination
                        disable-sort
                        style="max-height: 11vh; min-height: 11vh; overflow-y: auto"
                    >
                      <template v-slot:item.action="{ item }">
                        <v-btn
                            class=""
                            text
                            icon
                            color="green"
                            @click="currentArtiCount = (item.work.menge + '').replace('.', ','); currentArtiUnit = item.amount.split(' ')[item.amount.split(' ').length-1] ;currentArtiId = item.id; showArtiCount = true;"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                            class=""
                            text
                            icon
                            color="red"
                            @click="deleteFahr(item.id)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showMain = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="!!errorStart || !!errorEnd || errorData"
              v-on:click.stop="$emit('save-block', {blocks: getResultingBlocks(), finishTodo: finishTodo}); showMain = false"
          >
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <select-task-dialog ref="select_task_dialog" :fehls="fehls" :augrs="augrs"
                        :hide-loader="hideLoader" :show-loader="showLoader"
                        :current-mita="currentMita" :object-map="objectMap"
                        :kost-mapping="schluesselMapping['KoAu']"
                        :migr-mapping="schluesselMapping['MiAu']"
                        :einzel-map="einzelMapping"
                        @selected-task="onTaskSelected"/>
    <select-lear-dialog ref="select_lear_dialog"
                        :legrs="legrs" :lear-map="learMap"
                        :current-mita="currentMita"
                        :kost-mapping="schluesselMapping['KoLe']"
                        :migr-mapping="schluesselMapping['MiLe']"
                        :categories="schluesselMapping['KaLe']"
                        :augr-mapping="schluesselMapping['AuLe']"
                        :current-augr="currentAugr"
                        :task-legr="taskLegr"
                        @selected-lear="onLearSelected"

    />
    <select-fahr-dialog ref="select_fahr_dialog" :fahrs="fahrs"
                        :leist="currentBlock.work.lear"
                        :leist-mapping="schluesselMapping['LeFa']"
                        :categories="schluesselMapping['KaFa']"
                        :special-car-module="specialCarModule"
                        :duration="duration" @save="onFahrSelected"/>
    <select-artis-dialog ref="select_artis_dialog" :artis="artis"
                        :categories="schluesselMapping['KaAr']" @save="onArtisSelected"/>
    <select-ez-dialog ref="select_ez_dialog" :ezs="surcharges" :duration="duration" @save="onEzsSelected"/>

    <v-dialog
        v-model="showFahrDuration"
        :max-width="'500px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Dauer wählen</span>
        </v-card-title>
        <v-card-text>
          <v-time-picker
              v-model="currentFahrDuration"
              format="24hr"
              :max="duration"
              landscape
          ></v-time-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showFahrDuration = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="timeRegex.test(currentFahrDuration) === false || currentFahrDuration > duration"
              v-on:click.stop="saveFahrDuration"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showEzDuration"
        :max-width="'500px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Dauer wählen</span>
        </v-card-title>
        <v-card-text>
          <v-time-picker
              v-model="currentEzDuration"
              format="24hr"
              :max="duration"
              landscape
          ></v-time-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showEzDuration = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="timeRegex.test(currentEzDuration) === false || currentEzDuration > duration"
              v-on:click.stop="saveEzDuration"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="showArtiCount"
        :max-width="'300px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Menge wählen</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
              label=""
              v-model="currentArtiCount"
              :suffix="currentArtiUnit"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showArtiCount = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="!currentArtiCount.replace(/[^0-9,-.]/g, '').replace(',','.') || parseFloat(currentArtiCount.replace(/[^0-9,-.]/g, '').replace(',','.')) <= 0"
              v-on:click.stop="saveArtiCount"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>

</template>

<script>

import {getUid} from "@/shared/crypto";
import SelectTaskDialog  from "@/views/zeitkontrolle/SelectTaskDialog.vue";
import SelectLearDialog  from "@/views/zeitkontrolle/SelectLearDialog.vue";
import  SelectFahrDialog from "@/views/zeitkontrolle/SelectFahrDialog.vue";
import SelectArtisDialog from "@/views/zeitkontrolle/SelectArtiesDialog.vue";
import SelectEzDialog from "@/views/zeitkontrolle/SelectEzDialog.vue";
import _orderBy from "lodash/orderBy"


export default {
  name: "TimeBlockDialog",
  components: {
    SelectTaskDialog,
    SelectLearDialog,
    SelectFahrDialog,
    SelectArtisDialog,
    SelectEzDialog
  },
  props: {
    currentMita: {
      type: Object,
      default: () => undefined
    },
    blockedIntervals: {
      type: Array,
      default: () => []
    },
    breaks: {
      type: Array,
      default: () => []
    },
    start: {
      type: String,
      default: () => undefined
    },
    end: {
      type: String,
      default: () => undefined
    },
    timeBlock: {
      type: Object,
      default: () => undefined
    },
    timeBlockSurcharges: {
      type: Array,
      default: () => []
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    augrs: {
      type: Array,
      default: () => []
    },
    objectMap: {
      type: Object,
      default: () => ({})
    },
    legrs: {
      type: Array,
      default: () => []
    },
    learMap: {
      type: Object,
      default: () => ({})
    },
    fehls: {
      type: Array,
      default: () => []
    },
    fahrs: {
      type: Array,
      default: () => []
    },
    artis: {
      type: Array,
      default: () => []
    },
    surcharges: {
      type: Array,
      default: () => []
    },
    schluesselMapping: {
      type: Object,
      default: () => ({})
    },
    einzelMapping: {
      type: Object,
      default: () => ({})
    },
    specialCarModule: {
      type: Boolean,
      default: () => false
    },
  },
  watch: {
    startTime(newVal, oldVal) {
      let newDuration = this.duration;
      let oldDuration = this.calculateDuration(oldVal, this.endTime);
      this.currentBlock.work.std = newDuration;
      this.currentBlock.work.von = newVal;
      for (let i = 0; i < this.currentBlock.children.length; i++) {
        if (this.currentBlock.children[i].type === 'FAGE' || this.currentBlock.children[i].type === 'LOHN') {
          this.currentBlock.children[i].work.von = newVal;
          if (this.currentBlock.children[i].work.std === oldDuration || this.currentBlock.children[i].work.std > newDuration) {
            this.currentBlock.children[i].work.std = newDuration;
          }
        }
      }
    },
    endTime(newVal, oldVal) {
      let newDuration = this.duration;
      let oldDuration = this.calculateDuration(this.startTime, oldVal);
      this.currentBlock.work.std = newDuration;
      this.currentBlock.work.bis = newVal;
      for (let i = 0; i < this.currentBlock.children.length; i++) {
        if (this.currentBlock.children[i].type === 'FAGE' || this.currentBlock.children[i].type === 'LOHN') {
          this.currentBlock.children[i].work.bis = newVal;
          if (this.currentBlock.children[i].work.std === oldDuration || this.currentBlock.children[i].work.std > newDuration) {
            this.currentBlock.children[i].work.std = newDuration;
          }
        }
      }
    },
  },
  computed: {
    currentAugr() {
      if (this.currentBlock && this.currentBlock.work && this.currentBlock.work.aufisn) {
        // iterate over the object map to find the object with the aufisn
        for (const key in this.objectMap) {
          let obj = this.objectMap[key].find(o => o.aufisn === this.currentBlock.work.aufisn);
          if (obj) {
            return obj.augr;
          }
        }
      }
      return "";
    },
    errorStart() {
      if (!this.startTime) {
        return 'Startzeit ist erforderlich.';
      } else if (this.endTime && this.startTime >= this.endTime) {
        return 'Startzeit muss vor Endzeit liegen.';
      }
      return this.errorInterval();
    },
    errorEnd() {
      if (!this.endTime) {
        return 'Endzeit ist erforderlich.';
      } else if (this.startTime && this.endTime <= this.startTime) {
        return 'Endzeit muss nach Startzeit liegen.';
      }
      return this.errorInterval();
    },
    errorData() {
      return !this.currentBlock.type || (this.currentBlock.type === 'ARBL' && !this.currentBlock.legr);
    },
    duration() {
      console.log(this.breaks)
      if (!!this.errorStart || !!this.errorEnd) {
        return '';
      }
      const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };
      const startMinutes = timeToMinutes(this.startTime);
      const endMinutes = timeToMinutes(this.endTime);
      let durationMinutes = endMinutes - startMinutes;

      this.breaks.forEach(block => {
        // Find the overlap boundaries
        const overlapStart = Math.max(startMinutes, timeToMinutes(block.startTime));
        const overlapEnd = Math.min(endMinutes, timeToMinutes(block.endTime));

        // If overlapStart < overlapEnd, there is a genuine overlap
        if (overlapStart < overlapEnd) {
          durationMinutes -= (overlapEnd - overlapStart);
        }
      });

      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;
      // bring to format HH:MM
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    },
    items_fahrs() {
      let res = [];
      for (let k = 0; k < this.currentBlock.children.length; k++) {
        if (this.currentBlock.children[k].type === 'FAGE') {
          let c = {...this.currentBlock.children[k]}
          c.amount = c.work.std ? c.work.std + " Std." : "Interval nicht gesetzt";
          res.push(c);
        }
      }
      return _orderBy(res, 'title');
    },
    items_artis() {
      let res = [];
      for (let k = 0; k < this.currentBlock.children.length; k++) {
        if (this.currentBlock.children[k].type === 'ARTI') {
          let a = this.getArti(this.currentBlock.children[k].work.objekt);
          let c = {...this.currentBlock.children[k]}
          c.amount = ((this.roundToDigits(c.work.menge, 2) + " ").replace('.', ',')) + ' ' + a.unit;
          res.push(c);
        }
      }
      return _orderBy(res, 'title');
    },
    items_surcharges() {
      let res = [];
      for (let k = 0; k < this.currentBlock.children.length; k++) {
        if (this.currentBlock.children[k].type === 'LOHN') {
          let c = {...this.currentBlock.children[k]}
          c.amount = c.work.std ? c.work.std + " Std." : "Interval nicht gesetzt";
          res.push(c);
        }
      }
      return _orderBy(res, 'title');
    },
  },
  data: () => ({
    timeRegex: /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/,
    startTime: '',
    startTimeEdit: '',
        endTime: '',
        endTimeEdit: '',
        currentBlock: {
          id: '',
          von: '',
          bis: '',
          task: '',
          title: '',
          legr: '',
          hinweis: '',
          images: [],
          type: '',
          children: [],
          work: {
            id: '',
            legr: "",
            objekt: "",
            von: '',
            bis: '',
            std: "",
            menge: 0.0,
            aufisn: "",
            posnr: "",
            lear: "",
            creator: "",
            created: "",
            grp: "",
            dep: '',
            typ: "",
            deployed: "",
            hinweis: "",
            tid: "",
          }
        },
        oldMita: '',
        showMain: false,
        showStart: false,
        showEnd: false,
    headers_surcharges: [
      { text: 'Dauer', value: 'amount', sortable: false, cellClass: 'cell-small'},
      { text: 'Zulage', value: 'title', sortable: false},
      { text: '', value: 'action', sortable: false, cellClass: 'cell-small'},
    ],
    headers_fahrs: [
      { text: 'Dauer', value: 'amount', sortable: false, cellClass: 'cell-small'},
      { text: 'Fahrzeug', value: 'title', sortable: false},
      { text: '', value: 'action', sortable: false, cellClass: 'cell-small'},
    ],
    headers_artis: [
      { text: 'Menge', value: 'amount', sortable: false, cellClass: 'cell-small'},
      { text: 'Material', value: 'title', sortable: false},
      { text: '', value: 'action', sortable: false, cellClass: 'cell-small'},
    ],

    showFahrDuration: false,
    currentFahrDuration: '',
    currentFahrId: '',

    showArtiCount: false,
    currentArtiCount: '',
    currentArtiId: '',
    currentArtiUnit: '',

    showEzDuration: false,
    currentEzDuration: '',
    currentEzId: '',
    taskLegr: '',
    showFinishTodo: false,
    finishTodo: false,
    }),
  methods: {
    roundToDigits (number, digits) {
      const roundTo = Math.pow(10, digits)
      return (Math.round(number * roundTo) / roundTo).toFixed(2)
    },
    calculateDuration(start, end) {
      if (!start || !end || start >= end) {
        return '';
      }
      const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };
      const startMinutes = timeToMinutes(start);
      const endMinutes = timeToMinutes(end);
      const durationMinutes = endMinutes - startMinutes;
      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;
      // bring to format HH:MM
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    },
    openDialog() {
      if (!this.timeBlock) {
        let id = getUid();
        this.currentBlock = {
          id: id,
          von: this.start,
          bis: this.end,
          task: '',
          title: '',
          legr: '',
          hinweis: '',
          images: [],
          type: '',
          children: [],
          work: {
            id: id,
            legr: "",
            objekt: "",
            von: this.start,
            bis: this.end,
            std: this.calculateDuration(this.start, this.end),
            menge: 0.0,
            aufisn: "",
            posnr: "",
            lear: "",
            creator: "",
            created: "",
            grp: "",
            dep: id,
            typ: "",
            deployed: "",
            hinweis: "",
            tid: "",
          }
        };
        this.startTime = this.start;
        this.startTimeEdit = this.start;
        this.endTime = this.end;
        this.endTimeEdit = this.end;
      } else {
        this.currentBlock = JSON.parse(JSON.stringify(this.timeBlock));
        this.startTime = this.timeBlock.von;
        this.startTimeEdit = this.startTime
        this.endTime = this.timeBlock.bis;
        this.endTimeEdit = this.endTime
      }
      this.taskLegr = '';
      this.finishTodo = false;
      this.showFinishTodo = false;
      this.showMain = true;
      console.log(this.currentBlock);
      if (this.startTime && this.endTime && this.currentBlock.type === '') {
        this.$refs.select_task_dialog.openDialog();
      }
      console.log(this.startTime)
      console.log(this.endTime)
    },
    unformateHours(hoursStr) {
      let parts = hoursStr.split(":");
      return parseInt(parts[0]) + (parseInt(parts[1]) / 60);
    },
    errorInterval() {
      const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };
      const startMinutes = timeToMinutes(this.startTime);
      const endMinutes = timeToMinutes(this.endTime);
      for (const block of this.blockedIntervals) {
        const existingStart = timeToMinutes(block.startTime);
        const existingEnd = timeToMinutes(block.endTime);
        const isNotOverlapping = endMinutes <= existingStart || existingEnd <= startMinutes;
        if (!isNotOverlapping) {
          return 'Das Interval ist schon definiert.'; // Overlap found!
        }
      }
      return '';
    },
    getFehl(id) {
      return this.fehls.filter(f => f.id === id)[0];
    },
    getAufisn(augr, id) {
      let items = this.objectMap[augr].filter(o => o.id === id);
      if (items.length > 0) {
        return items[0];
      }
      return null;
    },
    getLegr(legr) {
      return this.legrs.filter(l => l.name === legr)[0];
    },
    getLear(legr, lear) {
      let items = this.learMap[legr].filter(l => l.id === lear);
      if (items.length > 0) {
        return items[0];
      }
      return null;
    },
    onTaskSelected({augr, aufisn, task, fehl, einzel}) {
      this.taskLegr = '';
      this.showFinishTodo = false;
      this.finishTodo = false;
      this.currentBlock.work.objekt = this.currentMita.mita_key;
      if (fehl !== null) {
        let id = getUid();
        this.currentBlock = {
          id: id,
          von: this.start,
          bis: this.end,
          task: '',
          title: '',
          legr: '',
          hinweis: '',
          images: [],
          type: '',
          children: [],
          work: {
            id: id,
            legr: "",
            objekt: this.currentMita.mita_key,
            von: this.start,
            bis: this.end,
            std: this.calculateDuration(this.start, this.end),
            menge: 0.0,
            aufisn: "",
            posnr: "",
            lear: "",
            creator: "",
            created: "",
            grp: "",
            dep: id,
            typ: "",
            deployed: "",
            hinweis: "",
            tid: "",
          }
        }
        if (fehl === 'PAUSE') {
          this.currentBlock.type = 'PAUS';
          this.currentBlock.typ = 'PAUS';
          this.timeBlock.title = 'Pause';
        } else {
          let item = this.getFehl(fehl);
          this.currentBlock.type = 'FEHL';
          this.currentBlock.title = item.name;
          this.currentBlock.work.aufisn = item.bis_id;
          this.currentBlock.work.typ = 'FEHL';
        }
      } else if(aufisn !== null) {
        // just change existing block
        let item = this.getAufisn(augr, aufisn);
        this.currentBlock.type = 'ARBL';
        this.currentBlock.title = item.object;
        this.currentBlock.task = item.object;
        this.currentBlock.work.aufisn = item.aufisn;
        this.currentBlock.work.posnr = this.currentBlock.work.legr;
        this.currentBlock.work.tid = "";
        for (let i = 0; i < this.currentBlock.children.length; i++) {
          this.currentBlock.children[i].work.aufisn = item.aufisn;
          this.currentBlock.children[i].work.posnr = this.currentBlock.work.posnr;
          this.currentBlock.children[i].work.tid = "";
        }
        this.currentBlock.work.typ = "ARBL";
        if (this.currentBlock.legr === '') {
          this.$refs.select_lear_dialog.openDialog();
        }
      } else if (task !== null) {
        let auftragKeySplits = task.auftrag_key.split('.');
        if (auftragKeySplits.length < 2) {
          return;
        }
        let augrNumber = auftragKeySplits[0];
        let aufisn = auftragKeySplits[1];
        let posNr = '';
        if (auftragKeySplits.length > 2) {
          posNr = auftragKeySplits[2];
        }
        this.currentBlock.type = 'ARBL';
        this.currentBlock.title = task.auftrag_was;
        this.currentBlock.task = task.auftrag_wo;
        this.currentBlock.work.aufisn = aufisn;
        if (posNr !== '') {
          this.currentBlock.work.posnr = posNr;
        } else {
          this.currentBlock.work.posnr = this.currentBlock.work.legr;
        }
        this.currentBlock.work.tid = task.tid;
        for (let i = 0; i < this.currentBlock.children.length; i++) {
          this.currentBlock.children[i].work.aufisn = this.currentBlock.work.aufisn;
          this.currentBlock.children[i].work.posnr = this.currentBlock.work.posnr;
          this.currentBlock.children[i].work.tid = this.currentBlock.work.tid;
        }
        this.currentBlock.work.typ = "ARBL";
        this.taskLegr = task.legr;
        this.showFinishTodo = task.has_todo;
        if (this.currentBlock.legr === '') {
          this.$refs.select_lear_dialog.openDialog();
        }
      } else if (einzel !== null) {
        let auftragKeySplits = einzel.auftrag_key.split('.');
        if (auftragKeySplits.length < 2) {
          return;
        }
        let augrNumber = auftragKeySplits[0];
        let aufisn = auftragKeySplits[1];
        let posNr = '';
        if (auftragKeySplits.length > 2) {
          posNr = auftragKeySplits[2];
        }
        this.currentBlock.type = 'ARBL';
        this.currentBlock.title = einzel.auftrag_was;
        this.currentBlock.task = einzel.auftrag_wo;
        this.currentBlock.work.aufisn = aufisn;
        if (posNr !== '') {
          this.currentBlock.work.posnr = posNr;
        } else {
          this.currentBlock.work.posnr = this.currentBlock.work.legr;
        }
        for (let i = 0; i < this.currentBlock.children.length; i++) {
          this.currentBlock.children[i].work.aufisn = this.currentBlock.work.aufisn;
          this.currentBlock.children[i].work.posnr = this.currentBlock.work.posnr;
          this.currentBlock.children[i].work.tid = this.currentBlock.work.tid;
        }
        this.currentBlock.work.typ = "ARBL";
        this.taskLegr = einzel.legr;
        if (this.currentBlock.legr === '') {
          this.$refs.select_lear_dialog.openDialog();
        }
      }
    },
    onLearSelected({legr, lear}) {
      let legrGischl = this.getLegr(legr).gischl;
      let learItem = this.getLear(legr, lear);
      if (legrGischl.length > 4 && legrGischl.startsWith('00')) {
        legrGischl = legrGischl.substring(2);
      }
      this.currentBlock.legr = learItem.name;
      this.currentBlock.work.legr = legrGischl;
      this.currentBlock.work.lear = learItem.bis_id;
      if (this.currentBlock.work.posnr <= '0199') {
        this.currentBlock.work.posnr = legrGischl;
      }
      for (let i = 0; i < this.currentBlock.children.length; i++) {
        this.currentBlock.children[i].work.posnr = this.currentBlock.work.posnr;
        this.currentBlock.children[i].work.legr = this.currentBlock.work.legr;
        this.currentBlock.children[i].work.lear = this.currentBlock.work.lear;
      }
    },
    getFahr(access) {
      return this.fahrs.filter(f => f.access === access)[0];
    },
    onFahrSelected(fahrs) {
      // first sort out the fahrs we already have
      for (let k = 0; k < fahrs.length; k++) {
        let exists = false;
        for (let j = 0; j < this.currentBlock.children.length; j++) {
          if (this.currentBlock.children[j].type === 'FAGE' &&
              this.currentBlock.children[j].work.object === fahrs[k].access) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          let item = this.getFahr(fahrs[k].access);
          let id = getUid();
          let fahrBlock = {
            id: id,
            von: this.startTime,
            bis: this.endTime,
            task: '',
            title: item.name,
            legr: '',
            hinweis: '',
            images: [],
            type: 'FAGE',
            children: [],
            work: {
              id: id,
              legr: this.currentBlock.work.legr,
              objekt: fahrs[k].access,
              von: this.startTime,
              bis: this.endTime,
              std: fahrs[k].duration,
              menge: 0.0,
              aufisn: this.currentBlock.work.aufisn,
              posnr: this.currentBlock.work.posnr,
              lear: this.currentBlock.work.lear,
              creator: "",
              created: "",
              grp: "",
              dep: this.currentBlock.id,
              typ: "FAGE",
              deployed: "",
              hinweis: "",
              tid: this.currentBlock.work.tid,
            }
          };
          this.currentBlock.children.push(fahrBlock);
        }
      }
    },
    deleteFahr(id) {
      this.currentBlock.children = this.currentBlock.children.filter(c => c.id !== id);
    },
    saveFahrDuration() {
      for (let k = 0; k < this.currentBlock.children.length; k++) {
        if (this.currentBlock.children[k].id === this.currentFahrId) {
          this.currentBlock.children[k].work.std = this.currentFahrDuration;
          break;
        }
      }
      this.showFahrDuration = false;
    },
    getArti(access) {
      return this.artis.filter(a => a.access === access)[0];
    },
    onArtisSelected(artis) {
      // first sort out the artis we already have
      for (let k = 0; k < artis.length; k++) {
        let exists = false;
        for (let j = 0; j < this.currentBlock.children.length; j++) {
          if (this.currentBlock.children[j].type === 'ARTI' &&
              this.currentBlock.children[j].work.object === artis[k].access) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          let item = this.getArti(artis[k].access);
          let id = getUid();
          let artiBlock = {
            id: id,
            von: this.startTime,
            bis: this.endTime,
            task: '',
            title: item.name,
            legr: '',
            hinweis: '',
            images: [],
            type: 'ARTI',
            children: [],
            work: {
              id: id,
              legr: this.currentBlock.work.legr,
              objekt: item.access,
              von: this.startTime,
              bis: this.endTime,
              std: this.currentBlock.work.std,
              menge: artis[k].count,
              aufisn: this.currentBlock.work.aufisn,
              posnr: this.currentBlock.work.posnr,
              lear: this.currentBlock.work.lear,
              creator: "",
              created: "",
              grp: "",
              dep: this.currentBlock.id,
              typ: "ARTI",
              deployed: "",
              hinweis: "",
              tid: this.currentBlock.work.tid,
            }
          };
          this.currentBlock.children.push(artiBlock);
        }
      }
    },
    deleteArti(id) {
      this.currentBlock.children = this.currentBlock.children.filter(c => c.id !== id);
    },
    saveArtiCount() {
      for (let k = 0; k < this.currentBlock.children.length; k++) {
        if (this.currentBlock.children[k].id === this.currentArtiId) {
          this.currentBlock.children[k].work.menge = parseFloat(this.currentArtiCount.replace(/[^0-9,-.]/g, '').replace(',','.'));
          break;
        }
      }
      this.showArtiCount = false;
    },
    getEz(access) {
      return this.surcharges.filter(e => e.access === access)[0];
    },
    onEzsSelected(ezs) {
      // first sort out the ezs we already have
      for (let k = 0; k < ezs.length; k++) {
        let exists = false;
        for (let j = 0; j < this.currentBlock.children.length; j++) {
          if (this.currentBlock.children[j].type === 'LOHN' &&
              this.currentBlock.children[j].work.object === ezs[k].access) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          let item = this.getEz(ezs[k].access);
          let id = getUid();
          let ezBlock = {
            id: id,
            von: this.startTime,
            bis: this.endTime,
            task: '',
            title: item.name,
            legr: '',
            hinweis: '',
            images: [],
            type: 'LOHN',
            children: [],
            work: {
              id: id,
              legr: this.currentBlock.work.legr,
              objekt: ezs[k].access,
              von: this.startTime,
              bis: this.endTime,
              std: ezs[k].duration,
              menge: 0.0,
              aufisn: this.currentBlock.work.aufisn,
              posnr: this.currentBlock.work.posnr,
              lear: this.currentBlock.work.lear,
              creator: "",
              created: "",
              grp: "",
              dep: this.currentBlock.id,
              typ: "LOHN",
              deployed: "",
              hinweis: "",
              tid: this.currentBlock.work.tid,
            }
          };
          this.currentBlock.children.push(ezBlock);
        }
      }
    },
    deleteEz(id) {
      this.currentBlock.children = this.currentBlock.children.filter(c => c.id !== id);
    },
    saveEzDuration() {
      for (let k = 0; k < this.currentBlock.children.length; k++) {
        if (this.currentBlock.children[k].id === this.currentEzId) {
          this.currentBlock.children[k].work.std = this.currentEzDuration;
          break;
        }
      }
      this.showEzDuration = false;
    },
    getResultingBlocks() {
      const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };
      const minutesToTime = (minutes) => {
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
      };

      let intervals = this.getAvailableIntervals(this.startTime, this.endTime, this.breaks);
      console.log(intervals);
      console.log(this.breaks);
      if (intervals.length === 0) {
        return [];
      } else if (intervals.length === 1 && timeToMinutes(this.startTime) === intervals[0].start && timeToMinutes(this.endTime) === intervals[0].end) {
        // no split needed
        return [this.currentBlock];
      }
      // we need to split
      let resultingBlocks = [];
      let fahrDurations = new Map();
      let ezDurations = new Map();
      for (let i = 0; i < this.currentBlock.children.length; i++) {
        let child = this.currentBlock.children[i];
        if (child.type === 'FAGE') {
          fahrDurations.set(child.work.objekt, timeToMinutes(child.work.std));
        } else if (child.type === 'LOHN') {
          ezDurations.set(child.work.objekt, timeToMinutes(child.work.std));
        }
      }
      for (let i = 0; i < intervals.length; i++) {
        let interval = intervals[i];
        let id = getUid();
        let newBlock = {
          id: id,
          von: minutesToTime(interval.start),
          bis: minutesToTime(interval.end),
          task: this.currentBlock.task,
          title: this.currentBlock.title,
          legr: this.currentBlock.legr,
          hinweis: this.currentBlock.hinweis,
          images: [...this.currentBlock.images],
          type: this.currentBlock.type,
          children: [],
          work: {
            id: id,
            legr: this.currentBlock.work.legr,
            objekt: this.currentBlock.work.objekt,
            von: minutesToTime(interval.start),
            bis: minutesToTime(interval.end),
            std: minutesToTime(interval.duration),
            menge: 0.0,
            aufisn: this.currentBlock.work.aufisn,
            posnr: this.currentBlock.work.posnr,
            lear: this.currentBlock.work.lear,
            creator: "",
            created: "",
            grp: "",
            dep: id,
            typ: this.currentBlock.work.typ,
            deployed: "",
            hinweis: this.currentBlock.work.hinweis,
            tid: this.currentBlock.work.tid,
          }
        };
        // add children
        for (let j = 0; j < this.currentBlock.children.length; j++) {
          let child = this.currentBlock.children[j];
          let childId = getUid();
          let remainingDuration = interval.duration;
          if (child.type === 'FAGE') {
            let possibleDuration = fahrDurations.get(child.work.objekt);
            if (possibleDuration < remainingDuration) {
              remainingDuration = possibleDuration;
            }
            fahrDurations.set(child.work.objekt, fahrDurations.get(child.work.objekt) - remainingDuration);
          }
          if (child.type === 'LOHN') {
            let possibleDuration = ezDurations.get(child.work.objekt);
            if (possibleDuration < remainingDuration) {
              remainingDuration = possibleDuration;
            }
            ezDurations.set(child.work.objekt, ezDurations.get(child.work.objekt) - remainingDuration);
          }
          if (remainingDuration <= 0) {
            continue;
          }
          if (child.type === 'ARTI' && i > 0) {
            // skip arti for all but first block
            continue;
          }
          let newChild = {
            id: childId,
            von: minutesToTime(interval.start),
            bis: minutesToTime(interval.end),
            task: child.task,
            title: child.title,
            legr: child.legr,
            hinweis: '',
            images: [],
            type: child.type,
            children: [],
            work: {
              id: childId,
              legr: child.work.legr,
              objekt: child.work.objekt,
              von: minutesToTime(interval.start),
              bis: minutesToTime(interval.end),
              std: minutesToTime(remainingDuration),
              menge: child.work.menge,
              aufisn: child.work.aufisn,
              posnr: child.work.posnr,
              lear: child.work.lear,
              creator: "",
              created: "",
              grp: "",
              dep: newBlock.id,
              typ: child.work.typ,
              deployed: "",
              hinweis: "",
              tid: child.work.tid,
            }
          };
          newBlock.children.push(newChild);
        }
        resultingBlocks.push(newBlock);
      }
      return resultingBlocks;
    },
    getAvailableIntervals(start, end, blocked) {
      // 1. Sort blocks and filter out those completely outside the range
      const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };

      const sortedBlocks = [...blocked]
          .filter(b => b.endTime > start && b.startTime < end)
          .sort((a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime));
      const result = [];
      let currentStart = timeToMinutes(start);

      sortedBlocks.forEach(block => {
        // Determine the actual boundaries of the block within our range
        const blockStart = Math.max(timeToMinutes(start), timeToMinutes(block.startTime));
        const blockEnd = Math.min(timeToMinutes(end), timeToMinutes(block.endTime));
        // If there's space between the current cursor and the start of this block
        if (blockStart > currentStart) {
          result.push({
            start: currentStart,
            end: blockStart,
            duration: blockStart - currentStart
          });
        }

        // Move the cursor to the end of the block, but don't move it backwards
        if (blockEnd > currentStart) {
          currentStart = blockEnd;
        }
      });

      // 3. Add the final interval if there's time left after the last block
      if (currentStart < timeToMinutes(end)) {
        result.push({
          start: currentStart,
          end: timeToMinutes(end),
          duration: timeToMinutes(end) - currentStart
        });
      }

      return result;
    }
  }
}
</script>

<style scoped>
  ::v-deep .v-input__slot>.v-label {
    margin-top: 9px;
  }

  ::v-deep .cell-small {
    max-width: 105px;
    width: 105px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
